class HeaderSearch extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.disclosure = this.querySelector('details');
    this.input = this.querySelector('.search__input');
    let boundKeyHandler = this.handleKey.bind(this);
    let boundClickOutside = this.handleClickOutside.bind(this);
    this.disclosure.addEventListener('toggle', () => {
      if (this.disclosure.open) {
        this.input.focus();
        document.addEventListener('keyup', boundKeyHandler);
        document.addEventListener('click', boundClickOutside);
      } else {
        document.removeEventListener('keyup', boundKeyHandler);
        document.removeEventListener('click', boundClickOutside);
      }
    });
  }

  closeDisclosure() {
    this.disclosure.open = false;
    this.disclosure.querySelector("summary").focus();
  }

  handleClickOutside(e) {
    if (!this.contains(e.target)) {
      this.closeDisclosure();
    }
  }

  handleKey(e) {
    if (e.key == "Escape") this.closeDisclosure();
  }
}

customElements.define('header-search', HeaderSearch);
